<style lang="scss" scoped>
    .helpful-hints {
        a {
            cursor: pointer;
        }
    }

    .section-name {
        color: #4d8ab7;
        font-weight: 300;
        font-size: 1.1em;
    }

    .modal-training-title {
        font-size: 2.0em;
        color: #fff;
    }

    .font-size-3em {
        font-size: 3.0em;
    }

    .yanone {
        font-family: "Yanone Kaffeesatz", sans-serif;
    }
</style>

<template>
    <div class="page-container">
        
        <section-collapse accordion="certification-accordion" id="certification-training-video">
            <template #title>Review Consultant Training Overview</template>
            <template #collapsed-content>
                Reviewing the Consultant Training Overview is the first step in becoming a certified Go NAPSACC Be Active Kids 
                trainer. Review the video and notes to learn more about the history of Be Active Kids, 
                it’s integration with Go NAPSACC, and how you can use the tools to help child care 
                providers meet their physical activity goals.
                <br/>
                <div class="section-name yanone">
                    <a href="#" @click.prevent="setVideoContent('panopto-video-embed', '5c0b538b-a8d1-4e1f-9a18-b09d0113018a')" data-toggle="modal" data-target="#session-modal">
                        View Video
                    </a>
                </div>
            </template>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-training-manual">
            <template #title>Review Consultant Manual</template>
            <template #collapsed-content>
                The Consultant Manual provides all of the resources you will need to hold a successful
                Build the Skills with Be Active Kids training. Review the Consultant Manual thoroughly
                as you are preparing to become a certified Go NAPSACC Be Active Kids trainer.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_consultant_manual.pdf'" target="_blank">Consultant Manual</a>
            </template>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-movement-guide">
            <template #title>Review Be Active Kids Movement Guide</template>
            <template #collapsed-content>
                The Be Active Kids Movement Guide is at the core of the Build the Skills with Be Active Kids training. This 
                evidence-informed resource provides over 85 developmentally appropriate activities 
                focused on practicing fundamental motor skills and movement concepts for children birth to 
                five. Review the Movement Guide to become familiar with its layout and how it will be used 
                in your Build the Skills with Be Active Kids trainings.
                <br/>
                <a :href="$basePath + '/be-active-kids/bak_movement_guide.pdf'" target="_blank">Be Active Kids Movement Guide</a>
            </template>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-training-slides">
            <template #title>Review Provider Training</template>
            <template #collapsed-content>
                The Provider Training includes a pdf of the slides and script that you will need to conduct a Build the Skills with Be Active Kids training with child care providers. Review this document to become familiar with the training content and learn how you can modify based off your chosen delivery method (virtual, in-person, or hybrid). In Step 2 you will be provided a PowerPoint  file of the Provider Training slides and a separate pdf file of the Provider Training Script.
                <br />
                <a :href="$basePath + '/be-active-kids/bts_provider_training_slides.pdf'" target="_blank">Provider Training</a>
            </template> 
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-quiz">
            <template #title>Complete Consultant Certification Quiz</template>

            <template #collapsed-content>
                Completing the quiz is the final step to becoming a certified Go NAPSACC Be Active Kids trainer. 
                You may reference any of the files above as you are completing the quiz. 
                You must get 8 out of 10 questions correct to successfully pass the quiz and download your certificate.
                <br/>
                <a href="#" @click.prevent="this.setVideoContent('build-the-skills-assessment')" data-toggle="modal" data-target="#session-modal">Open Consultant Quiz</a>
            </template>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-certificate">
            <template #title>Download Certificate of Completion</template>
            <template #collapsed-content>
                <template v-if="!enableCertificate">
                    Once you have successfully completed your Certification Quiz, you may download your certificate of completion.
                </template>
                <template v-else>
                    Congratulations on becoming a certified Go NAPSACC Be Active Kids trainer! You are now ready to move on to Step 2 and start leading Build the Skills with Be Active Kids provider training sessions.
                    <br />
                    <a href="#" @click.prevent="this.setVideoContent('build-the-skills-certificate');" data-toggle="modal" data-target="#session-modal">Open Completion Certificate</a>
                </template>
            </template>
        </section-collapse>
    </div>
</template>

<script>

    import SectionCollapse from '../SectionCollapse';
    import { mapMutations } from 'vuex';

    export default {
        props: {
            enableCertificate: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        components: {
            SectionCollapse
        },
        data: () => {
            return {
                currentComponent: null,
                currentVideoId: null,
            }
        },
        methods: {
            setVideoContent(component, videoId) {
                this.setCurrentContentComponent({currentContentComponent: component});
                this.setShowContent({showContent: true});
            },
            onVideoModalHidden() {
                this.resetContent();
            },
            resetContent() {
                this.currentComponent = null;
                this.currentVideoId = null;
            },
            ...mapMutations({
                setCurrentContentComponent: 'SET_CURRENT_CONTENT_COMPONENT',
                setShowContent: 'SET_SHOW_CONTENT',
            }),
        }
    }
</script>